var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconFlagDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27344 3.41016C6.27344 2.99594 5.93765 2.66016 5.52344 2.66016C5.10922 2.66016 4.77344 2.99594 4.77344 3.41016V21.9102C4.77344 22.3244 5.10922 22.6602 5.52344 22.6602C5.93765 22.6602 6.27344 22.3244 6.27344 21.9102V15.9102H19.0234C19.2779 15.9102 19.5151 15.7811 19.6533 15.5674C19.7914 15.3537 19.8118 15.0845 19.7074 14.8524L17.7344 10.4679C17.6463 10.2722 17.6463 10.0481 17.7344 9.85238L19.7074 5.46793C19.8118 5.23585 19.7914 4.96664 19.6533 4.75293C19.5151 4.53921 19.2779 4.41016 19.0234 4.41016H6.27344V3.41016ZM6.27344 5.91016V14.4102H17.8635L16.3665 11.0835C16.1023 10.4963 16.1023 9.82403 16.3665 9.23684L17.8635 5.91016H6.27344Z",
    fill: "#323544"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagDefault);
export default __webpack_public_path__ + "static/media/icon-flag-default.bb2d21bcbe453c14921b12df10c3bd72.svg";
export { ForwardRef as ReactComponent };